/**
 * Green Chiclets.
 */ var green = [
    {
        stopColor: '#7EF1B3',
        offset: 0
    },
    {
        stopColor: '#68D7FA',
        offset: 100
    }
];

export { green as default };
//# sourceMappingURL=green.es.js.map
